import { createApiAction } from 'helpers';

export const SAVE_CLIENT = 'SAVE_CLIENT';
export const SAVE_CLIENT_SUCCESS = 'SAVE_CLIENT_SUCCESS';
export const SAVE_CLIENT_FAILURE = 'SAVE_CLIENT_FAILURE';

export const CLEAR_CREATED_FIELD = 'CLEAR_CREATED_FIELD';

export const saveClient = createApiAction(SAVE_CLIENT);
